var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control mobile dsf_teas_student_wubie_Detail" },
    [
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "items" },
          _vm._l(_vm.courses, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "item",
                class: index == 0 ? "nomargin" : "",
              },
              [
                _c("div", { staticClass: "courseName" }, [
                  _vm._v(_vm._s(item.courseName)),
                ]),
                _c("div", { staticClass: "item-content" }, [
                  _c(
                    "div",
                    { staticClass: "item-content-common" },
                    [
                      _c("dsf-icon", { staticClass: "icon-icon-kcfl" }),
                      _c("div", { staticClass: "common-right" }, [
                        _vm._v(_vm._s(item.teachForm)),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-content-common" },
                    [
                      _c("dsf-icon", { staticClass: "icon-shijian" }),
                      _c("div", { staticClass: "common-right" }, [
                        _vm._v(_vm._s(item.courseTime)),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-content-common" },
                    [
                      _c("dsf-icon", { staticClass: "icon-touxiang" }),
                      _c("div", { staticClass: "common-right" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.teacherText ? item.teacherText : "暂无"
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-content-common" },
                    [
                      _c("dsf-icon", { staticClass: "icon-location-hollow" }),
                      _c("div", { staticClass: "common-right" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.placeText ? item.placeText : "暂无") +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "addance-content" }, [
          _vm._m(0),
          _c("div", { staticClass: "addance" }, [
            _c("div", { staticClass: "addance-common addance-common-first" }, [
              _c("div", { staticClass: "time" }, [
                _c("div", { staticClass: "time-title" }, [_vm._v("考勤状态:")]),
                _c(
                  "div",
                  {
                    staticClass: "time-content",
                    class: {
                      "text-green": _vm.result.resultValue === "1",
                      "text-blue": "678".indexOf(_vm.result.resultValue) !== -1,
                      "text-red": "1678".indexOf(_vm.result.resultValue) === -1,
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.result.resultText) + " ")]
                ),
              ]),
            ]),
            _vm.result.signInTime || _vm.result.signInPlace
              ? _c("div", { staticClass: "addance-common" }, [
                  _vm.result.signInTime
                    ? _c("div", { staticClass: "time" }, [
                        _c("div", { staticClass: "time-title" }, [
                          _vm._v("签到时间:"),
                        ]),
                        _c("div", { staticClass: "time-content" }, [
                          _vm._v(" " + _vm._s(_vm.result.signInTime) + " "),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.result.signInPlace
                    ? _c("div", { staticClass: "time lacation" }, [
                        _c("div", { staticClass: "time-title" }, [
                          _vm._v("签到地点:"),
                        ]),
                        _c("div", { staticClass: "time-content" }, [
                          _vm._v(_vm._s(_vm.result.signInPlace)),
                        ]),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.result.signOutTime || _vm.result.signOutPlace
              ? _c("div", { staticClass: "addance-common" }, [
                  _vm.result.signOutTime
                    ? _c("div", { staticClass: "time" }, [
                        _c("div", { staticClass: "time-title" }, [
                          _vm._v("签退时间:"),
                        ]),
                        _c("div", { staticClass: "time-content" }, [
                          _vm._v(" " + _vm._s(_vm.result.signOutTime) + " "),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.result.signOutPlace
                    ? _c("div", { staticClass: "time lacation" }, [
                        _c("div", { staticClass: "time-title" }, [
                          _vm._v("签退地点:"),
                        ]),
                        _c("div", { staticClass: "time-content" }, [
                          _vm._v(_vm._s(_vm.result.signOutPlace)),
                        ]),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm.result.attend
        ? _c(
            "div",
            { staticClass: "btn-scan", on: { click: _vm.clickAddance } },
            [_c("div", { staticClass: "btn" }, [_vm._v("开始考勤")])]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "leftLine" }),
      _c("div", { staticClass: "datetitle" }, [_vm._v("考勤情况")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }